<h1 mat-dialog-title>
    <mat-icon>image</mat-icon>
</h1>
<mat-dialog-content class="mat-typography">
    <img src="{{data.src}}" alt="Imagen">
</mat-dialog-content>
<div mat-dialog-actions align="center">
    <button mat-stroked-button [mat-dialog-close] type="button" color="primary">Cerrar</button>
</div>